export class FilterModel {
    constructor(data, view) {

        this.name = ko.observable(data.name);
        this.key = data.FilterId;
        this.id = `filter-${data.FilterId}`;

        this.view = view;
    }

    selected = ko.observable();
}

export class RangeFilterModel extends FilterModel {
    constructor(data, view) {
        super(data, view);
        
        this.name = ko.pureComputed(() => {
            if (this.active()) {
                return `${this.FilterName()}`;
            }

            return this.FilterName();
        });

        ko.mapping.fromJS(data, {}, this);
    }

    template = 'aside-filter__range-filter';
    selectedTemplate = 'selected__range-filter';

    active = ko.pureComputed(() => this.min() != this.Min() || this.max() != this.Max());

    min = ko.pureComputed(() => this.MinValue() || this.Min());
    max = ko.pureComputed(() => this.MaxValue() || this.Max());

    text = ko.pureComputed(() => {
        if (this.min() != this.Min() && this.max() != this.Max()) {
            return `${this.min()} - ${this.max()}`;
        }
        if (this.min() != this.Min()) {
            return `>= ${this.min()}`;
        }
        if (this.max() != this.Max()) {
            return `<= ${this.max()}`;
        }
    });

    apply(data) {
        if (this.min() != this.Min() || this.max() != this.Max()) {
            let filter = [];
            if (this.min() != this.Min()) {
                filter.push(`min_${this.min()}`);
            }

            if (this.max() != this.Max()) {
                filter.push(`max_${this.max()}`);
            }

            data[this.key] = filter.join("-");
        }
    }

    unselect = (option) => {
        this.MinValue(null);
        this.MaxValue(null);

        this.view.update();
    }

    filterChanged = (args) => {
        this.MinValue(args.min);
        this.MaxValue(args.max);

        this.view.update();
    }

    reset = () => {
        this.unselect();
    }
}

export class SelectFilterModel extends FilterModel {
    constructor(data, view) {
        super(data, view);

        ko.mapping.fromJS(data, this.mapping, this);
    }

    mapping = {
        Options: {
            key: data => ko.utils.unwrapObservable(data.Id),
            create: options => new OptionModel(options.data, this),
            update: options => ko.mapping.fromJS(options.data, options.target)
        }
    };

    name = ko.pureComputed(() => {
        if (this.active()) {
            return `${this.FilterName()}: ${this.selectedOptions().map(x => x.Text).join(",")}`;
        }

        return this.FilterName();
    });

    template = 'aside-filter__term-filter';
    selectedTemplate = 'selected__term-filter';

    active = ko.pureComputed(() => this.selectedOptions().length > 0);
    selectedOptions = ko.pureComputed(() => this.Options().filter(x => x.active()));

    query = ko.observable();

    filteredOptions = ko.pureComputed(() => {
        if (!this.query()) {
            return this.Options();
        }

        return this.Options().filter(x => x.Text.toLowerCase().includes(this.query().toLowerCase()));
    });

    apply(data) {
        if (this.selectedOptions().length) {
            data[this.key] = this.selectedOptions().map(x => x.Value).join(",");
        }
    }

    select = (option) => {
        const selected = option.Selected();

        this.Options().filter(x => x.active()).forEach(o => o.Selected(false));
        if (selected) {
            option.Selected(true);
        }

        this.view.update();
    }

    unselect = () => {
        this.reset();
    }

    reset = () => {
        this.Options().filter(x => x.active()).forEach(o => o.Selected(false));
        this.view.update();
    }
}


export class MultiSelectFilterModel extends SelectFilterModel {
    constructor(data, view) {
        super(data, view);
    }

    select = (option) => {
        //option.Selected(!option.Selected());

        this.view.update();
    }
}

export class TreeSelectFilterModel extends FilterModel {
    constructor(data, view) {
        super(data, view);
        ko.mapping.fromJS(data, this.mapping, this);
    }

    name = ko.pureComputed(() => {
        if (this.active()) {
            return `${this.selectedOptions().map(x => x.Text)}`;
        }

        return this.FilterName();
    });

    template = 'aside-filter__tree-filter';
    selectedTemplate = 'selected__term-filter';

    active = ko.pureComputed(() => this.selectedOptions().length > 0);
    options = ko.pureComputed(() => this.flattedOptions().filter(x => x.active()) || this.Options());
    filteredOptions = ko.pureComputed(() => this.Options().filter(x => x.Text.toLowerCase().includes(this.query().toLowerCase())));
    selectedOptions = ko.pureComputed(() => this.flattedOptions().filter(x => x.active()));

    mapping = {
        Options: {
            key: data => ko.unwrap(data.Id),
            create: options => new TreeOptionModel(options.data, this)
        }
    };

    apply(data) {
        if (this.selectedOptions().length) {
            data[this.key] = this.selectedOptions().map(x => x.Value).join(",");
        }
    }

    select = (option) => {
        if (option.Selected()) {
            if (option.parent) {
                this.select(option.parent);
            } else {
                this.unselect(option);
            }
        } else {
            this.selectedOptions().forEach(o => o.Selected(false));
            option.Selected(true);
        }

        this.view.update();
    };

    unselect = () => {
        this.Options().filter(x => x.active()).forEach(o => o.Selected(false));
        this.view.update();
    }

    reset = () => {
        this.selectedOptions().forEach(o => o.remove());
        this.view.update();
    }

    back = (option) => {
        if (!option.parent || !option.HasChildren && !option.parent.parent) {
            this.unselect(option);
            return;
        }

        if (option.HasChildren) {
            this.select(option.parent);
        } else {
            this.select(option.parent.parent);
        }
    }

    flattedOptions = () => this.Options().flatMap(x => x.flatted());
}

export class OptionModel {
    constructor(data, filter) {
        this.filter = filter;

        ko.mapping.fromJS(data, this.mapping(), this);
    }

    mapping() {
        return {
            observe: ["Selected"]
        }
    }

    active = ko.pureComputed(() => this.Selected())
    id = ko.pureComputed(() => `${this.filter.FilterId()}-${this.Value}`)

    select = () => {
        this.filter.select(this);
    }

    unselect = () => {
        this.filter.unselect(this);
    }
}

export class TreeOptionModel extends OptionModel {
    constructor(data, filter, parent) {
        super(data, filter);

        this.parent = parent;
    }

    mapping() {
        return {
            observe: ["Options", "Selected"],
                Options: {
                key: data => ko.unwrap(data.Id),
                    create: options => new TreeOptionModel(options.data, this.filter, this)
            }
        }
    }

    flatted = () => {
        let list = [this];

        list = list.concat(this.Options().flatMap(o => o.flatted()));

        return list;
    }

    active = ko.pureComputed(() => this.Selected())
    id = ko.pureComputed(() => `opt-${this.Value}`)
    css = ko.pureComputed(() => {
        let classes = [];

        if (this.Selected()) {
            classes.push("fw-bold");
        }

        return classes.join(" ");
    });

    unselect = () => {
        this.filter.unselect(this);
    }

    backItem = ko.pureComputed(() => {
        if (this.HasChildren && this.parent) {
            return this.parent;
        } else if (!this.HasChildren && this.parent && this.parent.parent) {
            return this.parent.parent;
        } else {
            return null;
        }
    });
}

export class QueryFilterModel extends FilterModel {
    constructor(data, view) {
        super(data, view);

        ko.mapping.fromJS(data, this.mapping, this);
    }

    selectedTemplate = 'selected__query-filter';

    active = ko.pureComputed(() => {
        const query = this.Query();
        return query && query.length > 0;
    });

    apply(data) {
        if (this.Query()) {
            data["q"] = this.Query();
        }
    }

    unselect = () => {
        this.reset();
    }

    reset = () => {
        this.Query(null);
        this.view.update();
    }
}